(() => {
  const selector = '[data-ns-header]';

  function init(header) {
    if (!header || header.dataset.nsHeaderReady === 'true') return;
    const toggle = header.querySelector('[data-ns-menu-toggle]');
    const panel = header.querySelector('[data-ns-mobile-menu]');
    if (!toggle || !panel) return;

    header.dataset.nsHeaderReady = 'true';
    let previousOverflow = '';

    const close = (returnFocus = false) => {
      if (panel.hidden) return;
      panel.hidden = true;
      header.classList.remove('is-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
      document.documentElement.style.overflow = previousOverflow;
      if (returnFocus) toggle.focus();
    };

    const open = () => {
      if (!panel.hidden) return;
      previousOverflow = document.documentElement.style.overflow;
      panel.hidden = false;
      header.classList.add('is-menu-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close menu');
      document.documentElement.style.overflow = 'hidden';
    };

    header.nsHeaderClose = close;

    toggle.addEventListener('click', () => {
      if (panel.hidden) open();
      else close(false);
    });

    panel.querySelectorAll('[data-ns-menu-close]').forEach((button) => {
      button.addEventListener('click', () => close(true));
    });

    panel.addEventListener('click', (event) => {
      if (event.target.closest('a[href]')) close(false);
    });

    header.querySelectorAll('.ns-header__quote, .ns-header__phone, .ns-header-actions a').forEach((link) => {
      link.addEventListener('click', () => close(false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) close(true);
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 990) close(false);
    });
  }

  function initAll(root = document) {
    if (root.matches && root.matches(selector)) init(root);
    root.querySelectorAll(selector).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const header = event.target.querySelector && event.target.querySelector(selector);
    if (header && header.nsHeaderClose) header.nsHeaderClose(false);
  });
})();
